/** ArticleShortAnswer (G2, D9): eyebrow label + the 40–60-word answer. The panel is the section's surfaceRole (PR5). */
import React, { memo } from 'react';
import type { ArticleBlockProps } from '@modules/screen-view-v2/components/screens/FlexibleLayout/article/types';
import { resolveLocaleText } from '@modules/screen-view-v2/utils/articleText';

export const ArticleShortAnswer = memo(function ArticleShortAnswer({ section, locale }: ArticleBlockProps): React.ReactElement | null {
  const content = section.articleShortAnswerContent;
  const text = resolveLocaleText(content?.text, locale);
  if (!text) return null;
  const label = resolveLocaleText(content?.label, locale);
  return (
    <div className="ap-block ap-answer">
      {label ? <p className="ap-eyebrow">{label}</p> : null}
      <p className="ap-answer-text">{text}</p>
    </div>
  );
});

ArticleShortAnswer.displayName = 'ArticleShortAnswer';
